import { render } from "./BTable.vue?vue&type=template&id=0d861f3f&scoped=true&ts=true"
import script from "./BTable.vue?vue&type=script&lang=ts"
export * from "./BTable.vue?vue&type=script&lang=ts"

import "./BTable.vue?vue&type=style&index=0&id=0d861f3f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d861f3f"]])

export default __exports__